import React, {useMemo} from "react";

import {Button, Col, Row} from "antd";
import BookCover from "@components/book-cover";
import {formatTitleCase} from "@lib/format";
import {ChevronRightIcon} from "@components/icons/Icons";
import {useWindowSize} from "@components/window-size-provider";
import {stopClickEvent} from "@lib/utils";

const SearchSeriesListItem = ({ item, onClick }) => {
    const windowDimensions = useWindowSize();

    const issueRange = useMemo(() => {
        return item.issue_min && item.issue_max
            ? `#${item.issue_min} - #${item.issue_max}`
            : item.issue_min
                ? `#${item.issue_min}`
                : item.issue_max
                    ? `#${item.issue_max}`
                    : null;
    }, [item]);
    
    const yearRange = useMemo(() => {
        return item.year_began && item.year_ended ? `${item.year_began} - ${item.year_ended}` : item.year_began ? item.year_began : item.year_ended ? item.year_ended : null;
    }, [item]);

    return (
        <a href={item.series_permalink}  className={"search-grid-item"}>
            <Row className="text-black grid-list-item cursor-pointer">
                {windowDimensions.isLargeScreen ? (
                    <>
                        <Col span={2} onClick={stopClickEvent}>
                            <div className="col-image">
                                <BookCover issue={item} onClick={onClick}/>
                            </div>
                        </Col>
                        <Col span={2}/>
                        <Col span={6} className="col-desc">
                            <Row className="series-title">
                                {item.series_title}
                            </Row>
                            {item.volume_name && (
                                <Row>
                                    Vol.{item.volume_name}
                                </Row>
                            )}
                        </Col>
                        <Col span={3} className="flex-col">
                            <div className="col-center">
                                {yearRange}
                            </div>
                        </Col>
                        <Col span={3} className="flex-col">
                            <div className="col-center">
                                {issueRange}
                            </div>
                        </Col>
                        <Col span={3} className="flex-col">
                            <div className="col-center">
                                {formatTitleCase(item.publisher, 'Unknown Publisher')}
                            </div>
                        </Col>
                        <Col span={3} className="flex-col">
                            <div className="col-center">
                                {formatTitleCase(item.format)}
                            </div>
                        </Col>
                        <Col span={1} className="flex-col">
                            <div className="flex-align-center flex-vertical-center height-100" >
                                <Button
                                    type="text"
                                    size="large"
                                    className="pad-0-10"
                                    href={item.series_permalink}
                                >
                                    <ChevronRightIcon className="icon30 iconGrey"/>
                                </Button>
                            </div>
                        </Col>
                    </>
                ) : (
                    <>
                        <Col span={7} className="flex-col flex-align-center" onClick={stopClickEvent}>
                            <div className="col-image cursor-pointer">
                                <BookCover issue={item} onClick={onClick}/>
                            </div>
                        </Col>
                        <Col span={14} className="col-desc">
                            <Row className="series-title">
                                {item.series_title}
                            </Row>
                            <Row>
                                {issueRange} {item.volume_name && (<>| Vol.{item.volume_name}</>)} | {yearRange}
                            </Row>
                            <Row>
                                {item.publisher && item.format ?
                                `${formatTitleCase(item.publisher, 'Unknown Publisher')} | ${formatTitleCase(item.format)}` : item.publisher ? formatTitleCase(item.publisher, 'Unknown Publisher') : item.format ? formatTitleCase(item.format) : null}
                            </Row>
                        </Col>
                        <Col span={3} className="small-screen-actions">
                            <Button
                            type="text"
                            size="large"
                            className="pad-0-10"
                            href={item.series_permalink}
                            >
                                <ChevronRightIcon className="icon30 iconGrey"/>
                            </Button>
                        </Col>
                    </>
                )}
            </Row>
        </a>
    );

};

export default SearchSeriesListItem;